import React, { useState, useEffect } from 'react';

const Buttontoptop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Check if the user has scrolled down a certain distance
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) { // You can adjust the scroll distance here
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This makes the scroll smooth
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility); // Add scroll event listener

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    isVisible && (
      <button
        onClick={scrollToTop}
        style={{
          position: 'fixed',
          bottom: '98px',
          right: '25px',
          padding: '10px 20px',
          backgroundColor: '#0310A8',
          color: 'white',
          border: '1px solid white',
          borderRadius: '5px',
          cursor: 'pointer',
          fontSize: '32px',
          zIndex: '11111',
        }}
      >
        ↑ 
      </button>
    )
  );
};

export default Buttontoptop;
